// extracted by mini-css-extract-plugin
module.exports = {"promoPopup":"shoppyBot_promoPopup__etsM4","visible":"shoppyBot_visible__N7C71","closeButton":"shoppyBot_closeButton___qtUl","branch-animation":"shoppyBot_branch-animation__YziQp"};